import { createTheme } from '@material-ui/core/styles';
import zIndex from '@material-ui/core/styles/zIndex';
import { isMobileApp } from '../mobile-app/mobileAppHandlers';
import {
  mainBoxShadow,
  smallBoxShadow,
  space,
  Breakpoints,
  ColorsPaletteLight,
} from "./constants";
import createBreakpoints from '@material-ui/core/styles/createBreakpoints';
import { fontSize, ingMeWebBold, ingMeWebRegular } from 'common-react';

export const themeLight = createTheme({
  props: {
    MuiButtonBase: {
      disableRipple: true, /* Disable ripple, on the whole application */
    },
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        'h1, h2, h3, h4, h5, h6, p, span': {
          margin: 0,
          padding: 0,
        },
        'html': {
          '-webkit-text-size-adjust': '100%',
        },
        'body': {
          color: ColorsPaletteLight.greys[80],
          backgroundColor: ColorsPaletteLight.greys[10],
        },
        '.MuiPaper-root': {
          backgroundColor: ColorsPaletteLight.greys[0],
          color: ColorsPaletteLight.greys[80],
        },
        '*': {
          '-webkit-tap-highlight-color': 'transparent',
        },
        '*:not(input):not(textarea)': isMobileApp()
          ? {
            userSelect: 'none',
            touchCallout: 'none',
            userDrag: 'none',
            '-webkit-user-drag': 'none',
            '-webkit-touch-callout': 'none',
            '-webkit-user-select': 'none',
            '-webkit-tap-highlight-color': 'transparent',
          }
          : {},
      },
    },
  },
  breakpoints: createBreakpoints({
    values: Breakpoints,
  }),
  zIndex: {
    modal: isMobileApp() ? 9899 : zIndex.modal,
  },
  typography: {
    fontFamily: ingMeWebRegular //set GoldmanSansRegular as default font
  },
  fontFamily: {
    ingMeWebRegular,
    ingMeWebBold
  },
  fontSize,
  boxShadow: {
    main: mainBoxShadow,
    small: smallBoxShadow,
  },
  space: {
    appPadding: space.appPadding,
    navCollapseWidth: space.navCollapseWidth,
    navWidth: space.navWidth,
    maxWidth: space.maxWidth,
    singleColumnMaxWidth: space.singleColumnMaxWidth,
    allocationProcessMaxWidth: space.allocationProcessMaxWidth,
    basicDataMaxWidth: space.basicDataMaxWidth,
    fundDetailsBackgroundMaxWidth: space.fundDetailsBackgroundMaxWidth,
    fundDetailsMaxWidthDefault: space.fundDetailsMaxWidthDefault,
    bottomBarMaxWidth: space.bottomBarMaxWidth,
    headerHeight: space.headerHeight,
    headerMobileHeight: space.headerMobileHeight,
    layoutMaxWidth: space.layoutMaxWidth,
    mobileNavHeight: space.mobileNavHeight,
    mobileBottomPadding: space.mobileBottomPadding,
    mobileTopPadding: space.mobileTopPadding,
  },
  palette: {
    background: {
      default: ColorsPaletteLight.greys[15],
    },
  },
  variables: {
    isDarkTheme: false,
  },
  color: ColorsPaletteLight,
});
